export default __webpack_public_path__ + "static/media/help-support-img.580f90c3.png";